export class Error404 {
    constructor(content, search) {
        this.SELECTOR_SEARCH_BUTTON = "";
        const openSearchButton = content.querySelector("a.open-search");
        this.siteSearch = search;
        if (openSearchButton) {
            openSearchButton.addEventListener("click", (event) => this.onOpenSearchClick(event));
        }
    }
    onOpenSearchClick(event) {
        event.preventDefault();
        this.siteSearch.openSearch();
        return false;
    }
}
